// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__2Gm16","body":"Modal_body__2rGrQ","content":"Modal_content__3pW4X","wrapper":"Modal_wrapper__3PjBT"};